// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__2G74Q","content":"Page_content__13v6R","scrollingDisabled":"Page_scrollingDisabled__2_ZR1"};